import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import styled from "styled-components";
import howToGetStartedImage from "../../assets/images/how-to-get-started.jpg";
import { colors } from "../../utils/Colors";
import { useAuthContext } from "../../features/authentication";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  position: relative;
  width: 90vw;
  height: 90vh;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      transform: scale(0.9);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  font-size: 32px;
  cursor: pointer;
  color: #333;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
  z-index: 10;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);

  &:hover {
    background-color: #fff;
    color: #000;
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
    font-size: 28px;
  }
`;

const WelcomeImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  border-radius: 8px;
`;

const GotItButton = styled.button`
  width: 100%;
  padding: 14px 24px;
  background-color: ${colors.primary};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${colors.primaryDark || "#0056b3"};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const FirstTimeUserModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    // Check if user has seen the modal before
    const hasSeenModal = localStorage.getItem("hasSeenWelcomeModal");
    
    if (!hasSeenModal) {
      // Show modal after a short delay for better UX
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    // Mark modal as seen in localStorage
    localStorage.setItem("hasSeenWelcomeModal", "true");
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={handleClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={handleClose} aria-label="Close modal">
          <IoMdClose />
        </CloseButton>
        
        <WelcomeImage 
          src={howToGetStartedImage} 
          alt="How to Get Started with GigFalcon" 
        />
      </ModalContent>
    </ModalOverlay>
  );
};

export default FirstTimeUserModal;
